export class Template {
  public id?: number;
  public name: string;
  public location: string;
  public category?: string;
  public langue?: string;
}
